export default __webpack_public_path__ + "static/media/f06.928f7ea4.svg";